<template>
  <v-expand-transition>
    <v-banner
      v-if="shouldDisplay"
      single-line
      :color="bannerColor"
      data-cy="orders-queue-banner"
    >
      <div
        class="d-flex justify-center align-center font-weight-medium"
        :class="darkText ? 'tp-text-subtitle-semibold' : 'tp-text-subtitle-semibold-white'"
      >
        <v-icon left small :color="darkText ? '#1f243c' : 'white'">
          mdi-clock-fast
        </v-icon>
        {{ $t('components.ordersQueue.label', { count }) }}
      </div>
    </v-banner>
  </v-expand-transition>
</template>

<script>
// The banner stays hidden below YELLOW_FROM and turns red at RED_FROM.
const YELLOW_FROM = 25;
const RED_FROM = 40;

export default {
  name: 'OrdersQueueBanner',
  computed: {
    shouldDisplay() {
      return (
        this.$store.getters.shouldDisplayOrdersQueue &&
        this.count >= YELLOW_FROM
      );
    },
    count() {
      return this.$store.getters.ordersQueueCount;
    },
    bannerColor() {
      return this.count >= RED_FROM ? '#E53935' : '#FBC02D';
    },
    darkText() {
      return this.count < RED_FROM;
    },
  },
  mounted() {
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  },
  methods: {
    onVisibilityChange() {
      // The count resets at midnight restaurant time without an event,
      // so refresh it when the guest returns to the tab.
      if (document.visibilityState === 'visible') {
        this.$store.dispatch('fetchOrdersQueue');
      }
    },
  },
};
</script>
